import ClipboardItem from './ClipboardItem';

class TextItem extends ClipboardItem {
  constructor(rawItem, status = ClipboardItem.STATUS_PERSISTED) {
    const { id, content_type, content_url, created_at } = rawItem;
    
    super(id, status, content_type, content_url, created_at);

    this.raw = rawItem; // Store raw item for reference
    this._content = null;
    this._isLoading = false;
    this._error = null;
    this._lastFetchTime = null;
    this._cacheExpiry = 5 * 60 * 1000; // 5 minutes
  }

  getContentUrl() {
    return this.contentUrl;
  }

  // Get content (from cache or fetch)
  async getContent() {
    return this.fetchContent();
  }

  // Fetch content from URL
  async fetchContent() {
    console.log('fetching content from url', this.getContentUrl()); 

    try {
      const response = await fetch(this.getContentUrl());
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const content = await response.text();
      this._content = content;
      this._lastFetchTime = Date.now();
      this._isLoading = false;

      return content;
    } catch (error) {
      this._error = error.message;
      this._isLoading = false;
      return null;
    }
  }

  getType() {
    return 'text';
  }
}

export default TextItem;
